import React from "react";

import Essentials from "./Essentials/Essentials";
import HeadingRow from "./HeadingRow/HeadingRow";
import Learnings from "./Learnings/Learnings";
import UserExperience from "./UserExperience/UserExperience";
import UserFeedback from "./UserFeedback/UserFeedback";

const GettingStarted = () => {
  return (
    <div>
      <h1>Getting Started </h1>
      <Essentials />
      <HeadingRow
        heading="See how users really experience your product"
        imageUrl="/images/features.jpg"
      />
      <UserExperience />
      <HeadingRow
        heading="Gather user feedback"
        imageUrl="/images/feedback.jpg"
      />
      <UserFeedback />
      <HeadingRow heading="Share your learnings" imageUrl="/images/share.jpg" />
      <Learnings />
    </div>
  );
};

export default GettingStarted;
